import { IZoomConnection, TConnection } from '../../../../../../../api/blueprints/connection.template.types';
import { FieldKey } from './connection-zoom-form.config';
import { BaseConnectionFormVM } from '../base-connection-form.viewmodel';
import { BaseBlueprintFormVM } from '../../../../../blueprint-form-base.viewmodel';
import { action } from 'mobx';
import { IReactIntlProvider } from '../../../../../../../infrastructure/react-intl-provider';
import * as IoC from 'typescript-ioc';
import { ZOOM_CONNECTION_DUPLICATE_ERROR_TEXT } from '../conections-list.texts';
import { FormVmItemConfigType } from '../../../../../../../infrastructure/form-viewmodel-controller';
import { ConnectionVersion } from '../../../../../../../constants/common.constants';

export class ConnectionZoomFormVM extends BaseConnectionFormVM {
    constructor(
        protected connection: TConnection,
        protected formConfigList: FormVmItemConfigType[],
        protected readonly addConnection: (connection: TConnection) => void,
        protected readonly editConnection: (connection: TConnection) => void,
        protected readonly connectionVersion: ConnectionVersion = ConnectionVersion.V1,
        private readonly isAutoSyncLimitReached: boolean,
        private readonly intlProvider: IReactIntlProvider = IoC.Container.get(IReactIntlProvider),
    ) {
        super(connection, formConfigList, addConnection, editConnection, connectionVersion);
    }

    public get showAutoRegAndAutoSyncToggles(): boolean {
        return !this.isAutoSyncLimitReached
            || (this.isEditMode && (this.connection as IZoomConnection).autoSyncEnabled);
    }

    @action.bound
    public submitForm(): void {
        const shouldThrowError = !this.showAutoRegAndAutoSyncToggles && this.formVM.getValue(FieldKey.AUTO_SYNC_ENABLED) && !this.isEditMode;

        if (shouldThrowError) {
            this.formVM.setValue(FieldKey.AUTO_REGISTRATION_ENABLED, false);
            this.formVM.setValue(FieldKey.AUTO_SYNC_ENABLED, false);
            const intl = this.intlProvider.getIntl();

            BaseBlueprintFormVM.handleInternalException(intl.formatMessage(ZOOM_CONNECTION_DUPLICATE_ERROR_TEXT));
            return;
        }

        super.submitForm();
    }
}
